<template>
  <div class="mb-4 text-sm">
    <router-link :to="to" class="hover:underline underline-offset-1">
      < Back to {{ title }}
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'Breadcrumb',
  props: {
    to: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true,
    }
  }
}
</script>
